import Accordion from 'react-bootstrap/Accordion'
import { stringifyRecursive, isPreactSignal } from '../utils/utils.js'

export default function DebugAccordion(props) {
    // return immediately unless we have debug enabled either via the props or from localStorage
    if (!props.data) {
        return null
    }
    const isDebug = localStorage.debug === 'true'
    if (!props.debug && !isDebug) {
        return null
    }
    const data = Array.isArray(props.data) ? props.data : [props.data]
    const items = data.map(d => {
        return (
            <Accordion.Item eventKey={d.name} key={d.name}>
                <Accordion.Header>{d.name}</Accordion.Header>
                <Accordion.Body>
                    <pre>{stringifyRecursive(isPreactSignal(d.data) ? d.data.value : d.data, true)}</pre>
                </Accordion.Body>
            </Accordion.Item>
        )
    })

    return (
        <Accordion className="my-5" alwaysOpen>
            {items}
        </Accordion>
    )
}